import polyglotI18nProvider from 'ra-i18n-polyglot';
import {
    Admin,
    CustomRoutes,
    Resource,
    localStorageStore,
    useStore,
    StoreContextProvider,
} from 'react-admin';
import { Route } from 'react-router';

import authProvider from './authProvider';
import categories from './categories';
import { Dashboard } from './dashboard';
import dataProviderFactory from './dataProvider';
import englishMessages from './i18n/en';
import invoices from './invoices';
import { Layout, Login } from './layout';
import orders from './orders';
import products from './products';
import reviews from './reviews';
import Segments from './segments/Segments';
import visitors from './visitors';
import apikesy from './apikeys';
import packages from './packages';
import { themes, ThemeName } from './themes/themes';
import OAuthCallback from './oauth/OAuthCallback';
import functions from './functions';
import datasets from './datasets';

const i18nProvider = polyglotI18nProvider(
    locale => {
        if (locale === 'fr') {
            return import('./i18n/fr').then(messages => messages.default);
        }

        // Always fallback on english
        return englishMessages;
    },
    'en',
    [
        { locale: 'en', name: 'English' },
        { locale: 'fr', name: 'Français' },
    ]
);

const store = localStorageStore(undefined, 'UniteStream');

const App = () => {
    const [themeName] = useStore<ThemeName>('themeName', 'radiant');
    const lightTheme = themes.find(theme => theme.name === themeName)?.light;
    const darkTheme = themes.find(theme => theme.name === themeName)?.dark;
    return (
        <Admin
            title=""
            dataProvider={dataProviderFactory(
                process.env.REACT_APP_DATA_PROVIDER || ''
            )}
            store={store}
            authProvider={authProvider}
            dashboard={Dashboard}
            loginPage={Login}
            layout={Layout}
            i18nProvider={i18nProvider}
            disableTelemetry
            lightTheme={lightTheme}
            darkTheme={darkTheme}
            defaultTheme="light"
            authCallbackPage={false}
        >
            <CustomRoutes>
                <Route path="/segments" element={<Segments />} />
                <Route path="/oauth-callback" element={<OAuthCallback />} />
            </CustomRoutes>
            <Resource name="datasets" {...datasets} />
            {/*<Resource name="apikeys" {...apikesy} />*/}
            {/*<Resource name="packages" {...packages} />*/}
            {/*<Resource name="functions" {...functions} />*/}

            {/*<Resource name="customers" {...visitors} />*/}
            {/*<Resource name="orders" {...orders} />*/}
            {/*<Resource name="invoices" {...invoices} />*/}
            {/*<Resource name="products" {...products} />*/}
            {/*<Resource name="categories" {...categories} />*/}
            {/*<Resource name="reviews" {...reviews} />*/}
        </Admin>
    );
};

const AppWrapper = () => (
    <StoreContextProvider value={store}>
        <App />
    </StoreContextProvider>
);

export default AppWrapper;
